import React, { useEffect, useState } from 'react'
import {
    Box, Button, FormControl, FormLabel, Input, useToast, VStack, Text
} from '@chakra-ui/react'
import { fetchWrapper } from '../../helpers'

const CustomerSupport = ({ id ,customer}) => {
    const [custSupportKey, setCustSupportKey] = useState('')
    const [loading, setLoading] = useState(false)
    const toast = useToast()

    const handleSubmit = async () => {
        if (!custSupportKey.trim()) {
            toast({ title: 'Support key is required', status: 'warning', duration: 3000, isClosable: true })
            return
        }
        setLoading(true)
        try {
            const url = `${process.env.REACT_APP_API_URL}/customer/cust-support-key`
            await fetchWrapper.post(url, { customer_id: id, cust_support_key: custSupportKey })
            toast({ title: 'Support key updated successfully', status: 'success', duration: 3000, isClosable: true })
        } catch (error) {
            toast({ title: 'Failed to update support key', status: 'error', duration: 3000, isClosable: true })
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        setCustSupportKey(customer?.cust_support_key ?? '')
    }, [customer?.cust_support_key])
   return (
        <Box maxW="480px" p={4}>
            <Text fontSize="15px" fontWeight="600" color="#111827" mb={4}>Customer Support Key</Text>
            <VStack spacing={4} align="stretch">
                <FormControl>
                    <FormLabel fontSize="13px" color="#374151" fontWeight="500">Support Key</FormLabel>
                    <Input
                        placeholder="Enter support key"
                        value={custSupportKey}
                        onChange={(e) => setCustSupportKey(e.target.value)}
                        size="sm"
                        borderColor="#d1d5db"
                        _focus={{ borderColor: '#3b82f6', boxShadow: '0 0 0 1px #3b82f6' }}
                    />
                </FormControl>
                <Button
                    colorScheme="blue"
                    size="sm"
                    onClick={handleSubmit}
                    isLoading={loading}
                    alignSelf="flex-start"
                >
                    Save
                </Button>
            </VStack>
        </Box>
    )
}

export default CustomerSupport
